import { If } from "../../../components/control-statements";
import { Label } from "../../../components/Label";
import { Checkbox } from "../../../components/Checkbox";
import { Hairline } from "@components";

const USE_TYPES = {
  ONLINE: 1,
  OFFLINE: 2,
  TAKEAWAY: 4,
  FASTFILA: 8,
};

const isType = (haystack, needle) => (needle & haystack) >= needle;

export const BenefitUseTypeStep = ({ benefit, onChange }) => {
  const isFreeDelivery = benefit.type === "FREE_DELIVERY";

  return (
    <>
      <Label text="Onde o benefício poderá ser utilizado?" />
      <Hairline className="mt-15 mb-15" />
      <div className="d-flex flex-column gap-10">
        <If cond={!isFreeDelivery}>
          <Checkbox
            label="Salão"
            family="useType"
            checked={isType(benefit.type_use, USE_TYPES.OFFLINE)}
            onChange={() =>
              onChange({
                ...benefit,
                type_use: isType(benefit.type_use, USE_TYPES.OFFLINE)
                  ? benefit.type_use & ~USE_TYPES.OFFLINE
                  : benefit.type_use | USE_TYPES.OFFLINE,
              })
            }
          />
        </If>
        <Checkbox
          label="Delivery"
          family="useType"
          checked={isType(benefit.type_use, USE_TYPES.ONLINE)}
          onChange={() =>
            onChange({
              ...benefit,
              type_use: isType(benefit.type_use, USE_TYPES.ONLINE)
                ? benefit.type_use & ~USE_TYPES.ONLINE
                : benefit.type_use | USE_TYPES.ONLINE,
            })
          }
        />
        <If cond={!isFreeDelivery}>
          <Checkbox
            label="Para viagem"
            family="useType"
            checked={isType(benefit.type_use, USE_TYPES.TAKEAWAY)}
            onChange={() =>
              onChange({
                ...benefit,
                type_use: isType(benefit.type_use, USE_TYPES.TAKEAWAY)
                  ? benefit.type_use & ~USE_TYPES.TAKEAWAY
                  : benefit.type_use | USE_TYPES.TAKEAWAY,
              })
            }
          />
        </If>
        <If cond={!isFreeDelivery}>
          <Checkbox
            label="Consumo no local"
            family="useType"
            checked={isType(benefit.type_use, USE_TYPES.FASTFILA)}
            onChange={() =>
              onChange({
                ...benefit,
                type_use: isType(benefit.type_use, USE_TYPES.FASTFILA)
                  ? benefit.type_use & ~USE_TYPES.FASTFILA
                  : benefit.type_use | USE_TYPES.FASTFILA,
              })
            }
          />
        </If>
      </div>
    </>
  );
};
